import React, { useState, useEffect } from 'react';
import { SearchIcon } from '@heroicons/react/outline';
import { Input, notification, Switch } from 'antd';
import ResponsiveDataTable from '../../components/common/ResponsiveDataTable';
import DefaultLayout from '../../components/layout/DefaultLayout';
import CreateUser from '../../components/users/create-user';
import usersService from '../../services/users';
import moment from 'moment';
import Errors from '../../components/errors';

const UsersScreen = () => {
  const [users, setUsers] = useState([]);
  const [changeStatusTask, setChangeStatusTask] = useState({
    loading: false,
    id: null,
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const { users } = await usersService.getUsers();

      setUsers(users);
    } catch (error) {
      notification.error({
        type: 'error',
        message: error.message
          ? error.message
          : 'Ocurrió un error al obtener los usuarios',
          placement: 'bottomRight'
      });
    }
  };

  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Correo electrónico',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Nombre de usuario',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Tipo usuario',
      dataIndex: 'admin',
      key: 'admin',
      render: (text, record) => (
        <div>{record.admin ? 'Admininistrador' : 'Usuario'}</div>
      ),
    },
    {
      title: 'Fecha registro',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text, record) => (
        <div>{moment(text).format('YYYY-MM-DD hh:mm a')}</div>
      ),
    },

    {
      title: 'Estado',
      key: 'status',
      render: (text, record) => (
        <Switch
          checked={record.status}
          loading={
            changeStatusTask.loading && changeStatusTask.id === record.id
          }
          disabled={
            changeStatusTask.loading && changeStatusTask.id === record.id
          }
          onChange={(status) => changeUserStatus(record.id, status)}
        />
      ),
    },
  ];

  const changeUserStatus = async (id, status) => {
    try {
      setChangeStatusTask({ loading: true, id });
      const response = await usersService.patchUser(id, status);

      const index = users.findIndex((user) => user.id === id);

      users.splice(index, 1, response.user);

      setUsers([...users]);

      notification.open({ type: 'success', message: response.message, placement: 'bottomRight' });

      setChangeStatusTask({ loading: false, id: null });
    } catch (error) {
      setChangeStatusTask({ loading: false, id: null });
      notification.open({
        type: 'error',
        message: 'Ocurrio un error al guardar el usuario',
        description: <Errors errors={error?.errors} />,
        placement: 'bottomRight'
      });
    }
  };

  return (
    <DefaultLayout>
      <div className="p-10">
        <h1 className="text-3xl lg:text-4xl font-bold">Usuarios</h1>

        <div className="mt-2 lg:flex justify-between">
          <CreateUser onUserCreated={(user) => setUsers([...users, user])} />

          <Input
            placeholder="Buscar por nombre, usuario o email"
            size="large"
            suffix={
              <SearchIcon width={24} className="text-black text-opacity-30" />
            }
            className="lg:w-96"
          />
        </div>

        <div className="mt-10">
          <ResponsiveDataTable columns={columns} dataSource={users} />
        </div>
      </div>
    </DefaultLayout>
  );
};

export default UsersScreen;
